// extracted by mini-css-extract-plugin
export default {"submitContainer":"components_submitContainer__C9y3a","formWrapper":"components_formWrapper__PXqZd","panel":"components_panel__7PmkQ"};